// item 61: floating WhatsApp button for fast questions in EN/ES.
// Uses the venue's phone number — verified in business.ts (phoneRaw).
// Round 3 Agent C: confirmed source-of-truth is business.phoneRaw, not a
// hardcoded number; `wa.me` expects E.164 without the leading "+", which
// the `replace(/\D/g, "")` below produces.
import { useEffect, useState } from "react";
import { business } from "../data/business";

const waNumber = business.phoneRaw.replace(/\D/g, "");
const waMessage = encodeURIComponent(
  "Hi! I have a question about booking a rafting trip on the Ocoee.",
);
const href = `https://wa.me/${waNumber}?text=${waMessage}`;

export function WhatsAppFab() {
  // Round 3 Agent C (item #16): drop the FAB while the soft keyboard is up
  // on mobile so it doesn't sit on top of the typing area. Same heuristic
  // MobileBottomBar uses (>20% visualViewport shrink). Feature-detected.
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useEffect(() => {
    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    if (!vv) return;
    const check = () => {
      const layoutH = window.innerHeight;
      const visualH = vv.height;
      if (!layoutH) return;
      setKeyboardOpen((layoutH - visualH) / layoutH > 0.2);
    };
    check();
    vv.addEventListener("resize", check);
    vv.addEventListener("scroll", check);
    return () => {
      vv.removeEventListener("resize", check);
      vv.removeEventListener("scroll", check);
    };
  }, []);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-fab ${keyboardOpen ? "is-keyboard-open" : ""}`}
      aria-label="Chat on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
        <path d="M16 3C9.4 3 4 8.4 4 15c0 2.4.7 4.6 1.9 6.4L4 29l7.8-2c1.7.9 3.7 1.4 5.7 1.4h.5c6.6 0 12-5.4 12-12 0-3.2-1.3-6.2-3.6-8.5C24.2 5.6 21.2 4.3 18 4.3 18 3.4 17.1 3 16 3zm-.5 22c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.6.9.9-3.5-.2-.4C6.4 18.7 6 17 6 15.2 6 9.7 10.5 5.2 16 5.2S26 9.7 26 15.2 21.5 25 16 25h-.5zm5.7-7.5c-.3-.2-1.7-.8-2-.9-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.2-.5-2.4-1.4-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.6 0-.2 0-.4-.1-.5-.1-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4 0 1.4 1 2.8 1.2 3 .2.2 2 3 4.7 4.2 1.7.7 2.3.8 3.1.7.5-.1 1.6-.7 1.8-1.3.2-.6.2-1.2.2-1.3-.1-.2-.3-.3-.6-.4z"/>
      </svg>
    </a>
  );
}
